import { getStore } from '../store/store';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
/**
 * Get the suggestions set based on the suggestion text
 */
export default function getSuggestionsSet() {
    var searchStore = getStore();
    /**
     * The default value of searchTextForSuggestion is null, so check for this
     * before attempting to get suggestions from the store since it is used as
     * the key.
     */
    var searchTextForSuggestion = searchStore.searchTextForSuggestion || '';
    var suggestionSet = is3SFeatureEnabled('sea-qf')
        ? searchStore.currentSuggestions
        : searchStore.suggestions.get(searchTextForSuggestion.trim());
    return suggestionSet;
}
//# sourceMappingURL=getSuggestionsSet.js.map